module.exports = "/static/assets/e450a0417017497cdfcc47d6fcbe2b34.png";